import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import BottomNav from "./components/BottomNav";
import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import Benefits from "./pages/Benefits";
import UnlockBenefits from "./pages/UnlockBenefits";
import Lounges from "./pages/Lounges";
import LoungeDetail from "./pages/LoungeDetail";
import LoungePass from "./pages/LoungePass";
import Hotels from "./pages/Hotels";
import HotelDetail from "./pages/HotelDetail";
import Insurance from "./pages/Insurance";
import FileClaim from "./pages/FileClaim";
import CarRental from "./pages/CarRental";
import TravelInsurance from "./pages/TravelInsurance";
import CoverageDetail from "./pages/CoverageDetail";
import EmergencyMedical from "./pages/EmergencyMedical";
import Concierge from "./pages/Concierge";
import Esim from "./pages/Esim";
import AirRefund from "./pages/AirRefund";
import StockBack from "./pages/StockBack";
import Profile from "./pages/Profile";
import Card from "./pages/Card";
import PhysicalCard from "./pages/PhysicalCard";
import ApplePay from "./pages/ApplePay";
import Banking from "./pages/Banking";
import Promotion from "./pages/Promotion";
import NearbyBenefits from "./pages/NearbyBenefits";
import "./App.css";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [hasSeenWelcome, setHasSeenWelcome] = useState(false);
  const isWelcome = location.pathname === "/welcome";

  function handleEnter() {
    localStorage.setItem("hasSeenWelcome", "true");
    setHasSeenWelcome(true);
  }

  return (
    <>
      <div className="app-shell">
        {!isWelcome && (
          <div className="status-bar">
            <span>20:36</span>
            <span className="status-icons">📶 🔋</span>
          </div>
        )}
        <div className="app-content">
          <Routes>
            <Route
              path="/welcome"
              element={<Welcome onEnter={handleEnter} />}
            />
            <Route path="/" element={hasSeenWelcome ? <Home /> : <Navigate to="/welcome" replace />} />
            <Route path="/benefits" element={<Benefits />} />
            <Route path="/unlock" element={<UnlockBenefits />} />
            <Route path="/benefits/choose" element={<Navigate to="/unlock" replace />} />
            <Route path="/lounges" element={<Lounges />} />
            <Route path="/lounges/:id" element={<LoungeDetail />} />
            <Route path="/lounges/:id/pass" element={<LoungePass />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/hotels/:id" element={<HotelDetail />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/insurance/claim" element={<FileClaim />} />
            <Route path="/travel-insurance" element={<TravelInsurance />} />
            <Route path="/travel-insurance/:id" element={<CoverageDetail />} />
            <Route path="/emergency-medical" element={<EmergencyMedical />} />
            <Route path="/car-rental" element={<CarRental />} />
            <Route path="/concierge" element={<Concierge />} />
            <Route path="/esim" element={<Esim />} />
            <Route path="/airrefund" element={<AirRefund />} />
            <Route path="/stock-back" element={<StockBack />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/card" element={<Card />} />
            <Route path="/physical-card" element={<PhysicalCard />} />
            <Route path="/apple-pay" element={<ApplePay />} />
            <Route path="/banking" element={<Banking />} />
            <Route path="/promotion" element={<Promotion />} />
            <Route path="/nearby" element={<NearbyBenefits />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        {!isWelcome && <BottomNav />}
      </div>
    </>
  );
}

export default App;
